<template>
<div>
    <h3 style="margin-top:50px;margin-bottom:40px;text-align: center;">
        ADA 订单管理
    </h3>
    <div style="width:400px;margin:auto">
    <a-form
      id="components-form-demo-normal-login"
      :form="form"
      class="login-form"
      @submit="handleSubmit"
    >
      <a-form-item>
        <a-input
          v-decorator="[
            'userName',
            { rules: [{ required: true, message: 'Please input your username!' }] },
          ]"
          placeholder="请输入登录名"
        >
          <a-icon slot="prefix" type="user" style="color: rgba(0,0,0,.25)" />
        </a-input>
      </a-form-item>
      <a-form-item>
        <a-input
          v-decorator="[
            'password',
            { rules: [{ required: true, message: 'Please input your Password!' }] },
          ]"
          type="password"
          placeholder="请输入密码"
        >
          <a-icon slot="prefix" type="lock" style="color: rgba(0,0,0,.25)" />
        </a-input>
      </a-form-item>
      <a-form-item>
        
        <a-button type="primary" html-type="submit" class="login-form-button">
          登录
        </a-button>
        
    
      </a-form-item>
    </a-form>
</div>
</div>
  </template>
  
  <script>
  import config from '../../util/config';
  export default {
    beforeCreate() {
      this.form = this.$form.createForm(this, { name: 'normal_login' });
    },
    methods: {
      handleSubmit(e) {
        e.preventDefault();
        this.form.validateFields((err, values) => {
          if (!err) {
            console.log(values);
            var postData = {};
            postData.name = values.userName;
            postData.password = values.password;
            this.$http.post(config.url + "/user",postData).then( res=>{
                if(res.data == null){
                    this.$message.info('登录失败');
                }
                else{
                    window.localStorage.setItem('token',JSON.stringify(res.data));
                    window.localStorage.setItem('role',res.data.role);
                    this.$router.push('/admin/orders')
                }
            })
          }
        });
      },
    },
  };
  </script>
  <style>
  #components-form-demo-normal-login .login-form {
    max-width: 300px;
  }
  #components-form-demo-normal-login .login-form-forgot {
    float: right;
  }
  #components-form-demo-normal-login .login-form-button {
    width: 100%;
  }
  </style>


// WEBPACK FOOTER //
// login.vue?131f2c23